import { accordion } from './modules/accordion';
import { CopyLink } from './modules/CopyLink';
import { lenis } from './modules/lenis';
import { tippyModule } from './modules/tippyModule';
import { Listing } from './modules/listing/Listing';
import { InspirationsPage } from './modules/inspirations/InspirationsPage';
import { initRecaptchaLazyLoad } from './modules/recaptcha-lazy-init';

var documentReady = function () {
    initRecaptchaLazyLoad();
    accordion();
    tippyModule();
    new CopyLink();

    if (document.querySelector('[data-inspirations]')) {
        new InspirationsPage();
    } else {
        new Listing();
    }

    // wyłączyc dla skecji z hero filmem lub na stronie z hero filemm
    lenis();
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
